import React, { useState, useEffect } from "react";
import "./FileContent.css";

/**
 * Public repos: fetches from GitHub contents API (legacy).
 * Private repos: blocked in Build 2B — no browser-side GitHub access (Build 2C proxy).
 */
const FileContent = ({ owner, repo, path, visibility, isPrivate }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const privateRepo =
    isPrivate === true || visibility === "private";

  useEffect(() => {
    if (!owner || !repo || !path) {
      setLoading(false);
      return;
    }

    if (privateRepo) {
      setLoading(false);
      setError(
        "Private file viewing is not available in the browser yet. Use Query Repository or Feature Builder for private repo analysis."
      );
      return;
    }

    const fetchContent = async () => {
      try {
        const response = await fetch(
          `https://api.github.com/repos/${owner}/${repo}/contents/${path}`
        );
        const data = await response.json();
        if (data.content) {
          const decodedContent = atob(data.content.replace(/\n/g, ""));
          setContent(decodedContent);
        }
      } catch (err) {
        setError("Failed to load file content");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [owner, repo, path, privateRepo]);

  if (loading) return <div className="file-content-loading">Loading...</div>;
  if (error) return <div className="file-content-error">{error}</div>;

  return (
    <div className="">
      <h3>File Content</h3>
      <pre className="file-content-code">
        <code>{content}</code>
      </pre>
    </div>
  );
};

export default FileContent;
